import React from 'react';
import styled from 'styled-components';

import { SelectField, PhoneField, TextField, ParagraphField } from '~fields';
import { Gap } from '~ui-kit';
import OpenHours from '../formik/components/OpenHours';

import { useOrganizationOptions, useUserOrganizationAsDefault } from '~hooks';

const DeceasedTransportsForm = props => {
  const {
    formId,
    formik: { setFieldValue },
    timeInfo,
  } = props;

  const organizationOptions = useOrganizationOptions({ formId });

  useUserOrganizationAsDefault({
    organizations: organizationOptions,
    change: value => setFieldValue('organization', value),
  });

  return (
    <Container>
      <ParagraphField name="infoParagraph" />
      {
        timeInfo && (
          <OpenHours
            timeInfo={timeInfo}
            urgency={{
              canBeUrgent: false,
            }}
          />
        ) // Show generic open hours
      }
      <Location>
        <SelectField
          required
          searchable
          name="organization"
          options={organizationOptions}
          fallbackLabel="Lähtöpiste"
          fallbackPlaceholder="Valitse"
        />
        <Gap height="8px" />
        <TextField
          required
          name="fromRoom"
          fallbackPlaceholder="Tarkka sijainti"
          flat
        />
      </Location>
      <PhoneField name="contactPhone" required />
    </Container>
  );
};

const Container = styled.div`
  max-width: var(--field-width);

  & > * {
    margin-bottom: 24px;
  }
`;

const Location = styled.div`
  max-width: var(--field-width);
`;

export default DeceasedTransportsForm;
